// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-aDJrI";
var _3 = "wrapper_disabled-3a0C7";
var _4 = "flightInfo_mobile-hvxq2";
var _5 = "flightInfo__iatas-2tKFm";
var _6 = "planeIcon-1kRaz";
var _7 = "flightInfo__cities-3dpqX";
var _8 = "flightInfo__dates-2fYWs";
var _9 = "flightInfo__time-1Kw6o";
var _a = "flightInfo__weather-LgWmL";
var _b = "weather-13YLf";
var _c = "weather__icon-23ISj";
var _d = "fareGroup-PkHAn";
var _e = "fareGroup__img-2Cmt4";
var _f = "fareGroup__info-1EEAE";
var _10 = "flightNumber-2wYti";
var _11 = "arrivalInfo-2NH1M";
var _12 = "arrivalInfo__place-3GdyG";
var _13 = "arrivalInfo__item-2NJ3t";
var _14 = "arrivalInfo__title-2y6J1";
var _15 = "mobileSegment__bottom-zz0TZ";
var _16 = "checkbox-3_W-z";
var _17 = "checkbox_checked-3CCmw";
export { _1 as "__esModule", _2 as "wrapper", _3 as "wrapper_disabled", _4 as "flightInfo_mobile", _5 as "flightInfo__iatas", _6 as "planeIcon", _7 as "flightInfo__cities", _8 as "flightInfo__dates", _9 as "flightInfo__time", _a as "flightInfo__weather", _b as "weather", _c as "weather__icon", _d as "fareGroup", _e as "fareGroup__img", _f as "fareGroup__info", _10 as "flightNumber", _11 as "arrivalInfo", _12 as "arrivalInfo__place", _13 as "arrivalInfo__item", _14 as "arrivalInfo__title", _15 as "mobileSegment__bottom", _16 as "checkbox", _17 as "checkbox_checked" }
export default { "__esModule": _1, "wrapper": _2, "wrapper_disabled": _3, "flightInfo_mobile": _4, "flightInfo__iatas": _5, "planeIcon": _6, "flightInfo__cities": _7, "flightInfo__dates": _8, "flightInfo__time": _9, "flightInfo__weather": _a, "weather": _b, "weather__icon": _c, "fareGroup": _d, "fareGroup__img": _e, "fareGroup__info": _f, "flightNumber": _10, "arrivalInfo": _11, "arrivalInfo__place": _12, "arrivalInfo__item": _13, "arrivalInfo__title": _14, "mobileSegment__bottom": _15, "checkbox": _16, "checkbox_checked": _17 }
